import StoreState from "../../interfaces/store/storeState";
import {Selector} from "./selectorType";

export const selectLoading: Selector<boolean> = (({mask: {isLoading}}: StoreState): boolean => isLoading);

export const selectExternalUrlLoading: Selector<boolean> = (({mask: {isExternalUrlLoading}}: StoreState): boolean => isExternalUrlLoading);
